const steps = [
  {
    number: "01",
    icon: "ri-chat-3-line",
    title: "Contato Inicial",
    description:
      "O cliente entra em contato via WhatsApp, e-mail ou formulário. Agendamos uma conversa inicial para compreender a situação e as necessidades.",
  },
  {
    number: "02",
    icon: "ri-file-search-line",
    title: "Análise do Caso",
    description:
      "Realizamos uma análise técnica e detalhada da situação apresentada, identificando fundamentos jurídicos, riscos e as melhores estratégias disponíveis.",
  },
  {
    number: "03",
    icon: "ri-map-pin-user-line",
    title: "Estratégia Definida",
    description:
      "Com base na análise, apresentamos um plano de atuação claro, transparente e orientado à proteção dos interesses e à segurança jurídica do cliente.",
  },
  {
    number: "04",
    icon: "ri-bar-chart-line",
    title: "Acompanhamento Contínuo",
    description:
      "Atuamos de forma contínua, mantendo o cliente informado em cada etapa, com dedicação e comprometimento até a conclusão do caso.",
  },
];

export default function ComoAtuamos() {
  return (
    <section id="como-atuamos" className="bg-petrol-darkest py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-gold-light/40" />
            <span className="text-gold-light text-xs font-semibold tracking-widest uppercase">
              Como Atuamos
            </span>
            <div className="w-8 h-px bg-gold-light/40" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Processo claro, <span className="text-gold-light">transparente</span> <br />
            e orientado ao cliente
          </h2>
          <p className="text-white/55 text-base max-w-lg mx-auto leading-relaxed">
            Nossa metodologia de trabalho garante que cada cliente saiba exatamente
            o que esperar em cada fase da sua causa.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-0 relative">
          {/* Connector line desktop */}
          <div className="hidden lg:block absolute top-16 left-[12.5%] right-[12.5%] h-px bg-gold-light/20" />

          {steps.map((step, idx) => (
            <div key={step.number} className="relative flex flex-col items-center text-center px-6 py-8">
              {/* Step circle */}
              <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full border-2 border-gold-light/50 bg-petrol-medium mb-6">
                <i className={`${step.icon} text-gold-light text-xl`} />
                {/* Number badge */}
                <div className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full bg-gold-light text-petrol-darkest text-xs font-bold">
                  {idx + 1}
                </div>
              </div>

              <h3 className="text-white font-semibold text-base mb-3">{step.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
